import * as ng from 'angular';
import {UISelectService} from '../../../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../../../services/archismall.service';
import {IListini, IProfile} from '../../../../../../commons/interfaces/listini';

const Limit = {
  FE: 'FE',
  CE: 'CE',
  PEC: 'PEC',
};

class CreaProfiloController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      listino: IListini,
      profilo: IProfile,
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService
  ) {
    $scope.pageHeader = 'Crea Profilo';
    $rootScope.formsubmitted = false;
    $scope.pageSubHeader = '';
    $scope.limit = $stateParams.limit;

    if ($stateParams.limit === 'PEC') {
      $scope.limitLabel = `${Limit.PEC} - MB`;
    } else if ($stateParams.limit === 'CE') {
      $scope.limitLabel = `${Limit.CE} - MB`;
    } else if ($stateParams.limit === 'FE') {
      $scope.limitLabel = `${Limit.FE} - invii fatture`;
    }

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.getListino = () => {
      ArchiSmallServices.getListino(store.get('idListino')).then(response => {
        $scope.listino = JSON.parse(JSON.stringify(response)) as IListini;
        if ($scope.listino.profileList === null || $scope.listino.profileList === undefined) {
          $scope.listino.profileList = [];
        }
        $scope.pageSubHeader = `${$scope.listino.name} - ${$scope.listino.code}`;
      });
    };
    $scope.getListino();

    $scope.selectTypeLimit = {
      'FE': 'FE',
      'CE': 'CE',
      'PEC': 'PEC',
    };

    $scope.openConfermaModal = (size) => {
      $scope.profilo.typeLimit = $scope.limit;
      $scope.listino.profileList.push($scope.profilo);

      // fare modal per conferma o altro vedi poi
      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'listiniComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          update: true,
          listino: () => {
            return $scope.listino;
          },
        }
      });
      setTimeout($scope.getListino, 3000);
      // $scope.getListino();
    };

    // $scope.creaProfilo = () => {
    //   $state.go('home.crea-profilo');
    // };

  }
}

export const CreaProfiloComponent: ng.IComponentOptions = {
  template: require('./crea-profilo.html'),
  controller: CreaProfiloController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-listino/crea-profilo/crea-profilo.ts